import { ReactElement } from 'react'
import styles from './MobileImpressumScreen.module.scss'
import { MobileBodyLarge, MobileHeadlineLarge, MobileTitleLarge } from '../../Typography'

export const MobileImpressumScreen = (): ReactElement => {
  return (
    <div className={styles.container}>
      <MobileHeadlineLarge>Impressum</MobileHeadlineLarge>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>FIGHTBACK Wrestling</MobileBodyLarge>
        <MobileBodyLarge>c/o German Hurricane Wrestling e. V.</MobileBodyLarge>
        <MobileBodyLarge>Goethestraße 13A</MobileBodyLarge>
        <MobileBodyLarge>64569 Nauheim</MobileBodyLarge>
      </div>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge fontWeight={700}>Vertreten durch:</MobileBodyLarge>
        <MobileBodyLarge>Aaron Krauser, Maurizio Bisignano, Sascha Döberin</MobileBodyLarge>
      </div>
      <MobileTitleLarge>Kontakt</MobileTitleLarge>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>+49 176 32646683</MobileBodyLarge>
        <MobileBodyLarge>office@fightback-wrestling.com</MobileBodyLarge>
      </div>
      <MobileTitleLarge>Rechtlich verantwortlich</MobileTitleLarge>
      <MobileBodyLarge>Aaron Krauser, Sascha Döberin</MobileBodyLarge>
      <MobileTitleLarge>Verbraucherstreitbeilegung / Universalschlichtungsstelle</MobileTitleLarge>
      <MobileBodyLarge>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </MobileBodyLarge>
    </div>
  )
}
